

const Testimonials = () => {

    return (
        <p>
            Lorem ipsum dolor sit amet consectetur adipisicing elit. Non, magni. Saepe harum ipsum distinctio ex eaque, consectetur, porro amet tempora facilis quod deserunt laborum consequatur, temporibus illum? Libero, sequi assumenda?
        </p>
    )
}

export default Testimonials